/**
 * Value-based upgrade nudge identifiers.
 * Higher priority wins when multiple could fire in the same session.
 */
export type NudgeId =
	| "out_of_coins"
	| "feature_boundary"
	| "aha_episode_finished"
	| "activation_podcast_ready"
	| "repeat_intent"
	| "low_balance";

export const NUDGE_PRIORITY: Record<NudgeId, number> = {
	out_of_coins: 100,
	feature_boundary: 90,
	aha_episode_finished: 80,
	activation_podcast_ready: 70,
	repeat_intent: 60,
	low_balance: 50,
};

/** Soft warning when roughly half of the free 120-coin grant is gone. */
export const LOW_BALANCE_THRESHOLD = 60;

/** Global cooldown between any two upgrade nudges. */
export const NUDGE_COOLDOWN_MS = 48 * 60 * 60 * 1000;

export interface NudgeContext {
	podcast_id?: string;
	podcast_count?: number;
	minutes_listened?: number;
	coin_balance?: number | null;
	trigger?: string;
	missing_coins?: number;
	required_coins?: number;
}
